import React, { useMemo, useEffect } from 'react';
import NewsDetail from './NewsDetail.jsx';
import Spinner from '../../../common/spinner/Spinner.jsx';
import { useParams } from 'react-router-dom';
import { useGetNewsDetailQuery } from '../../../../redux/services/news.jsx';
import { isUndefined } from 'lodash';
import usePermission from '../../../../hooks/usePermission.jsx';
import { useTranslation } from 'react-i18next';
import useScrollToTopOnMount from '../../../../hooks/useScrollToTopOnMount.jsx';
const NewsDetailPage = () => {
  useScrollToTopOnMount();

  const { slug } = useParams();
  const { i18n } = useTranslation();
  const { language } = i18n;
  const canShowNews = usePermission('news.show');

  const initialNews = useMemo(() => {
    const newsSlugEn = window?.initData?.newsDetail?.slug_en;
    const newsSlugSk = window?.initData?.newsDetail?.slug_sk;

    // if newsSlug is not undefined AND slug and newsSlug are same
    // return window.initData.newsDetail
    // otherwise return undefined => fetching is triggered automatically
    return (slug === newsSlugEn || slug === newsSlugSk)
      ? window.initData.newsDetail
      : undefined;
  }, [slug]);

  const { data: fetchedNewsDetail } = useGetNewsDetailQuery(slug, {
    skip: !isUndefined(initialNews),
  });

  const news = initialNews ?? fetchedNewsDetail;
  const languageFromSlug = useMemo(() => {
    if (!news) {
      return null;
    }

    const hasDistinctLanguageSlugs =
      !!news.slug_en &&
      !!news.slug_sk &&
      news.slug_en !== news.slug_sk;

    if (!hasDistinctLanguageSlugs) {
      return null;
    }

    if (!!news.slug_en && slug === news.slug_en) {
      return 'en';
    }

    if (!!news.slug_sk && slug === news.slug_sk) {
      return 'sk';
    }

    return null;
  }, [news, slug]);

  const isEnglish = languageFromSlug
    ? languageFromSlug === 'en'
    : language === 'en';

  useEffect(() => {
    if (!languageFromSlug || i18n.language === languageFromSlug) {
      return;
    }

    i18n.changeLanguage(languageFromSlug);
  }, [i18n, languageFromSlug]);

  // Update page title to the localized news title
  useEffect(() => {
    if (!news) return;
    const activeLanguage = languageFromSlug || language;
    const useEn = activeLanguage === 'en' && Boolean(news.display_en);
    const title = useEn
      ? news.title_en || news.title_sk || ''
      : news.title_sk || news.title_en || '';
    if (title) document.title = title;
  }, [language, languageFromSlug, news]);

  return !news ? (
    <Spinner />
  ) : (
    <NewsDetail
      newsDetail={news}
      isEnglishVersion={isEnglish}
      // display en version, when language is set to English and news has display_en set to 1
      displayEnglishVersion={isEnglish && Boolean(news.display_en)}
      displayEditIcon={canShowNews}
    />
  );
};

export default NewsDetailPage;
